import FileDownloadIcon from 'icons/file-download-solid.svg';

import React, {Fragment, useContext} from 'react';
import classNames from 'classnames';

import _ from 'topmeteo/utils/i18n';

import {useLightBox} from 'topmeteo/general/components/LightBox/Manager';

import {DrawingContext} from '../Drawing';

import ExportLightBox from './LightBox';
import Notification, {NotificationProvider} from './Notification';

const Label = _('Export');

const ExportButton = () => {
    const {waypoints: waypointsRef} = useContext(DrawingContext);
    const {show, onClick, ...props} = useLightBox();
    const waypoints = waypointsRef.current;
    const disabled = Boolean(waypoints && waypoints.length) === false;
    const className = classNames('export-button', {disabled});

    return (
        <Fragment>
            <button className={className} onClick={onClick} disabled={disabled} title={Label}>
                <img src={FileDownloadIcon} alt={Label} />
            </button>
            <NotificationProvider>
                {show && <ExportLightBox waypoints={waypointsRef.current} {...props} />}
                <Notification />
            </NotificationProvider>
        </Fragment>
    );
};

export default ExportButton;
